import { render } from "./OrganisationUsers.vue?vue&type=template&id=bd2258c0"
import script from "./OrganisationUsers.vue?vue&type=script&lang=js"
export * from "./OrganisationUsers.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__